/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_TariffRateResponse } from './billing_TariffRateResponse';
export type billing_TariffVersionResponse = {
    /**
     * AgeTransitionMonths is the BABY->CHILD threshold (months) for this version
     */
    age_transition_months?: number;
    /**
     * AgeTransitionMonthsSubsidised is the threshold (months) used for subsidised contracts
     */
    age_transition_months_subsidised?: number;
    /**
     * AgeTransitionTiming controls when the transition takes effect (FOLLOWING_MONTH or ON_BIRTHDAY)
     */
    age_transition_timing?: billing_TariffVersionResponse.age_transition_timing;
    /**
     * ContractCount is the number of contracts using this version
     */
    contract_count?: number;
    /**
     * CreatedAt timestamp
     */
    created_at?: string;
    /**
     * CreatedBy user ID
     */
    created_by?: string;
    /**
     * Description of the tariff version
     */
    description?: string;
    /**
     * GroupType this tariff applies to
     */
    group_type?: string;
    /**
     * ID is the unique identifier
     */
    id?: string;
    /**
     * IsDefault flag
     */
    is_default?: boolean;
    /**
     * Name of the tariff version
     */
    name?: string;
    /**
     * RateCount is the number of rates defined
     */
    rate_count?: number;
    /**
     * Rates contains all the tariff rates (optional, not always included)
     */
    rates?: Array<billing_TariffRateResponse>;
    /**
     * RoundingParentsAmount is the parent-side rounding step in Rappen
     */
    rounding_parents_amount?: number;
    /**
     * RoundingParentsEnabled toggles parent-side amount rounding for this version
     */
    rounding_parents_enabled?: boolean;
    /**
     * RoundingSubsidyAmount is the subsidy-side rounding step in Rappen
     */
    rounding_subsidy_amount?: number;
    /**
     * RoundingSubsidyEnabled toggles subsidy-side amount rounding for this version
     */
    rounding_subsidy_enabled?: boolean;
    /**
     * Status of the tariff version
     */
    status?: string;
    /**
     * UpdatedAt timestamp
     */
    updated_at?: string;
    /**
     * UpdatedBy user ID
     */
    updated_by?: string;
};
export namespace billing_TariffVersionResponse {
    /**
     * AgeTransitionTiming controls when the transition takes effect (FOLLOWING_MONTH or ON_BIRTHDAY)
     */
    export enum age_transition_timing {
        FOLLOWING_MONTH = 'FOLLOWING_MONTH',
        ON_BIRTHDAY = 'ON_BIRTHDAY',
    }
}

